import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-async-parallel',
  slug: 'parallel',
  title: 'Load the dashboard in parallel',
  type: 'code',
  estSeconds: 480,
  contentVersion: 1,
});
